module.exports = __webpack_public_path__ + "img/el_alquimista-logo_blanco.34cfaa49.svg";